import { Tables } from '@/supabase/types'

import { rewriteSupabaseStorageUrl } from '@/lib/media/safe-url'
import { supabase } from '@/lib/supabase/browser-client'

export const uploadAssistantImage = async (assistant: Tables<'assistants'>, image: File) => {
  const bucket = 'assistant_images'

  const imageSizeLimit = 6000000 // 6MB

  if (image.size > imageSizeLimit) {
    throw new Error(`Image must be less than ${imageSizeLimit / 1000000}MB`)
  }

  const currentPath = assistant.image_path
  let filePath = `${assistant.user_id}/${assistant.id}/${Date.now()}`

  if (currentPath.length > 0) {
    const { error: deleteError } = await supabase.storage.from(bucket).remove([currentPath])

    if (deleteError) {
      throw new Error('Error deleting old image')
    }
  }

  const { error } = await supabase.storage.from(bucket).upload(filePath, image, {
    upsert: true
  })

  if (error) {
    throw new Error('Error uploading image')
  }

  return filePath
}

import { getAssistantImageFromStorage as getResilientAssistantImage } from '@/lib/supabase/signed-url-manager'

export const getAssistantImageFromStorage = getResilientAssistantImage

export const getAssistantPublicImageUrl = (filePath: string) => {
  const { data } = supabase.storage.from('assistant_images').getPublicUrl(filePath)

  return rewriteSupabaseStorageUrl(data.publicUrl)
}
